/*eslint-disable*/

import classnames from "classnames";
// A great library for fuzzy filtering/sorting items
import {matchSorter} from "match-sorter";
import React from 'react';
// react plugin used to create DropdownMenu for selecting items
import Select from "react-select";

import {useFilters, usePagination, useSortBy, useTable,} from "react-table";
// reactstrap components
import {FormGroup, Input} from "reactstrap";

const getColumnDataFromRow = (row) =>
    Object.keys(row)
        .map((k) => k.match(/^column(\d+)_status$/))
        .filter(Boolean)
        .map((m) => parseInt(m[1], 10))
        .sort((a, b) => a - b)
        .map((n) => ({n, status: row[`column${n}_status`], units: row[`column${n}_units`]}));

// Define a default UI for filtering
function DefaultColumnFilter({
                                 column: {
                                     filterValue,
                                     preFilteredRows,
                                     setFilter,
                                     isNamedPlaceholder,
                                     Header,
                                     showColumn
                                 },
                             }) {
    const count = preFilteredRows.length;
    return (
        <FormGroup>
            <Input
                type="email"
                value={filterValue || ""}
                onChange={(e) => {
                    setFilter(e.target.value || undefined); // Set undefined to remove the filter entirely
                }}
                placeholder={isNamedPlaceholder ? Header : `Search ${count} records...`}
            />
        </FormGroup>
    );
}

function fuzzyTextFilterFn(rows, id, filterValue) {
    return matchSorter(rows, filterValue, {keys: [(row) => row.values[id]]});
}

// Let the table remove the filter if the string is empty
fuzzyTextFilterFn.autoRemove = (val) => !val;

// Our table component
function Table({columns, data}) {

    const [numberOfRows, setNumberOfRows] = React.useState(data.length);
    const [pageSelect, handlePageSelect] = React.useState(0);
    const filterTypes = React.useMemo(
        () => ({
            // Add a new fuzzyTextFilterFn filter type.
            fuzzyText: fuzzyTextFilterFn,
            // Or, override the default text filter to use
            // "startWith"
            text: (rows, id, filterValue) => {
                return rows.filter((row) => {
                    const rowValue = row.values[id];
                    return rowValue !== undefined
                        ? String(rowValue)
                            .toLowerCase()
                            .startsWith(String(filterValue).toLowerCase())
                        : true;
                });
            },
        }),
        []
    );


    const defaultColumn = React.useMemo(
        () => ({
            // Let's set up our default Filter UI
            Filter: DefaultColumnFilter,
        }),
        []
    );

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        page,
        prepareRow,
        state,
        visibleColumns,
        nextPage,
        pageOptions,
        pageCount,
        previousPage,
        canPreviousPage,
        canNextPage,
        setPageSize,
        gotoPage,
    } = useTable(
        {
            columns,
            data,
            defaultColumn, // Be sure to pass the defaultColumn option
            filterTypes,
            initialState: { pageSize: Math.max(data.length, 1), pageIndex: 0 },
        },
        useFilters, // useFilters!
        useSortBy,
        usePagination
    );

    // We don't want to render all of the rows for this example, so cap
    // it for this use case
    // const firstPageRows = rows.slice(0, 10);
    let pageSelectData = Array.apply(
        null,
        Array(pageOptions.length)
    ).map(function () {
    });
    let numberOfRowsData = [
        { label: '5 rows', value: 5 },
        { label: '10 rows', value: 10 },
        { label: '20 rows', value: 20 },
        { label: '25 rows', value: 25 },
        { label: '50 rows', value: 50 },
        { label: '100 rows', value: 100 },
        { label: '400 rows', value: 400 },
        { label: 'All rows', value: data.length }
    ];

    const goToMachine = (dashboardSerial) => {
        if (dashboardSerial) {
            document.location.href = `/user/device/details/${dashboardSerial}`
        }
        ;
    }

    const sumColumnValues = (columnId) => {
        return page.reduce((acc, row) => acc + row.original[columnId], 0);
    };

    const totalDailySales = sumColumnValues('daily_sales');
    const totalUnitsSum = sumColumnValues('total_units');
    const totalEmptyUnitsSum = sumColumnValues('total_empty_units');

    const handleCellStyleByColumnStatusAndQuantity = (columnStatus, columnQuantity) => {
        if (columnStatus === 0 || columnQuantity === 0) {
            return {color: 'red'}
        } else {
            if (columnQuantity < 10) {
                return {color: 'orange'}
            } else {
                return {color: '#00ffcc'}
            }
        }
    }

    return (
        <>
            <div className="ReactTable -striped -highlight ">
                <table {...getTableProps()} className="rt-table">

                    <thead className="rt-thead -header">

                    {headerGroups.map((headerGroup) => (
                        <>
                            <tr {...headerGroup.getHeaderGroupProps()} className="rt-tr">
                                {headerGroup.headers.map((column, key) => {
                                    return (<th
                                        {...column.getHeaderProps(column.getSortByToggleProps())}
                                        className={classnames("rt-th rt-resizable-header", {
                                            "-cursor-pointer": headerGroup.headers.length - 1 !== key,
                                            "-sort-asc": column.isSorted && !column.isSortedDesc,
                                            "-sort-desc": column.isSorted && column.isSortedDesc,
                                        })}
                                    >
                                        <div className="rt-resizable-header-content">
                                            {column.render("Header")}
                                        </div>
                                        {/* Render the columns filter UI */}
                                        <div>
                                            {headerGroup.headers.length - 1 === key
                                                ? null
                                                : column.canFilter
                                                    ? column.render("Filter")
                                                    : null}
                                        </div>
                                    </th>)
                                })}
                            </tr>
                            <tr {...headerGroup.getHeaderGroupProps()} className="rt-tr">
                                {headerGroup.headers.map((column, key) => {
                                    if (['daily_sales', 'total_units', 'total_empty_units'].includes(column.id)) {
                                        return (<th key={key + column.id + '-1'}
                                                    {...column.getHeaderProps(column.getSortByToggleProps())}
                                                    className={classnames("rt-th rt-resizable-header")}
                                        >
                                            <div className="rt-resizable-header-content">
                                                {column.id === 'daily_sales' ? totalDailySales : column.id === 'total_units' ? totalUnitsSum : totalEmptyUnitsSum}
                                            </div>
                                        </th>)
                                    } else if (column.id === 'dashboardName') {
                                        return (<th key={key + column.id + '-1'}
                                                    {...column.getHeaderProps(column.getSortByToggleProps())}
                                                    className={classnames("rt-th rt-resizable-header")}
                                        >
                                            <div className="text-right">
                                                SUM:
                                            </div>
                                        </th>)
                                    } else {
                                        return <th className={classnames("rt-th rt-resizable-header")}></th>
                                    }
                                })}
                            </tr>
                        </>
                    ))}
                    </thead>
                    <tbody {...getTableBodyProps()} className="rt-tbody">
                    {page.map((row, i) => {
                        let rowStyle = {}
                        if (row.original.lvl !== undefined) {
                            if (0 <= row.original.lvl && row.original.lvl < 100) {
                                rowStyle = {backgroundColor: 'black'}
                            } else if (100 <= row.original.lvl && row.original.lvl < 200) {
                                rowStyle = {backgroundColor: 'black'}
                            } else if (200 <= row.original.lvl && row.original.lvl < 300) {
                                rowStyle = {backgroundColor: 'blue'}
                            } else if (300 <= row.original.lvl && row.original.lvl < 400) {
                                rowStyle = {backgroundColor: 'red'}
                            } else if (400 <= row.original.lvl && row.original.lvl < 500) {
                                rowStyle = {}
                            }
                        }

                        prepareRow(row);
                        const {
                            expired,
                            dashboardSerial,
                        } = row.original;
                        const columnsData = getColumnDataFromRow(row.original);

                        return (
                            <tr
                                {...row.getRowProps()}
                                className={classnames(
                                    "rt-tr",
                                    {" -odd": i % 2 === 0},
                                    {" -even": i % 2 === 1},
                                )}
                                style={rowStyle ? {...rowStyle} : {...rowStyle}}
                            >
                                {row.cells.map((cell) => {
                                    let CellCurrentStyle = {}
                                    let CellContent;
                                    const colUnitsMatch = cell.column.id.match(/^column(\d+)_units$/);
                                    if (colUnitsMatch) {
                                        const n = parseInt(colUnitsMatch[1], 10);
                                        const colStatus = cell.row.original[`column${n}_status`];
                                        CellCurrentStyle = handleCellStyleByColumnStatusAndQuantity(colStatus, cell.value)
                                    } else if (cell.column.id === 'total_empty_units') {
                                        if (cell.value > 110) {
                                            CellCurrentStyle = {color: 'red'}
                                        } else if (cell.value > 80) {
                                            CellCurrentStyle = {color: 'orange'}
                                        }
                                    } else if (cell.column.id === 'device_status') {
                                        if (cell.value === 'OK') {
                                            CellCurrentStyle = {color: '#00ffcc'}
                                        } else {
                                            CellCurrentStyle = {color: 'red'}
                                        }

                                        CellContent = (
                                            <div className='column-status-wrapper'>
                                                {columnsData.map(({n, status, units}) => (
                                                    <div key={n}
                                                        className={status === 0 || units === 0 ? `column-status-wrapper-diod column-status-wrapper-diod-inactive` : units < 10 ? 'column-status-wrapper-diod column-status-wrapper-diod-warning' : `column-status-wrapper-diod column-status-wrapper-diod-active`}></div>
                                                ))}
                                            </div>
                                        )
                                    } else if (cell.column.id === 'heartbeat') {
                                        CellCurrentStyle = {
                                            color: expired ? 'red' : '#00ffcc',
                                            whiteSpace: 'nowrap',
                                        }
                                    } else if (cell.column.id === 'dashboardName') {
                                        CellCurrentStyle = {color: expired ? 'red' : '#00ffcc'}
                                    }
                                    return (
                                        <td {...cell.getCellProps()}
                                            className="rt-td"
                                            style={{...CellCurrentStyle}}
                                            onClick={() => goToMachine(dashboardSerial)}
                                        >
                                            {CellContent === undefined ? cell.render("Cell") : CellContent}
                                        </td>
                                    );
                                })}
                            </tr>
                        );
                    })}
                    </tbody>
                </table>
                <div className="pagination-bottom"></div>
            </div>
        </>
    );
}

// Define a custom filter filter function!
function filterGreaterThan(rows, id, filterValue) {
    return rows.filter((row) => {
        const rowValue = row.values[id];
        return rowValue >= filterValue;
    });
}

// This is an autoRemove method on the filter function that
// when given the new filter value and returns true, the filter
// will be automatically removed. Normally this is just an undefined
// check, but here, we want to remove the filter if it's not a number
filterGreaterThan.autoRemove = (val) => typeof val !== "number";

export default Table;
